import { map } from 'lodash';

export const createBreakpointList = (screens: {[key: string]: string}) => {
    const orderedNormalizedBreakpoints = map(screens, (min, bp) => {
        return { name: bp, min: removeUnit(min) };
    }).sort((a, b) => a.min - b.min);

    const breakpointArrayWithMax = map(orderedNormalizedBreakpoints, (bp, ix) => {
        let max;
        if (ix < orderedNormalizedBreakpoints.length - 1) {
            max = orderedNormalizedBreakpoints[ix + 1].min - 1;
        } else {
            max = 999999;
        }
        return { ...bp, ...{ max } };
    });

    return breakpointArrayWithMax.reduce((acc, bp) => {
        acc[bp.name] = { min: bp.min, max: bp.max };
        return acc;
    }, {});
};

function removeUnit(width: string): number {
    if (width.endsWith('px')) {
        return Number(width.slice(0, width.indexOf('p')));
    } else {
        return Number(width);
    }
}
